import {Absence} from './types';

export const MockData: Absence[] = [];
